import { useState } from 'react';

let isOpen = false;

export default isMobile => {
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalSettings, setModalSettings] = useState('');
  const [onClose, setOnClose] = useState(null);

  function onCloseEvents() {
    isOpen = false;
    setModal(false);
    document.body.style.overflow = 'visible';
    if (isMobile) window.removeEventListener('popstate', onCloseEvents);
    if (onClose) setOnClose(null);
  }

  function onOpenEvents() {
    isOpen = true;
    setModal(true);
    document.body.style.overflow = 'hidden';
    if (window.history.state !== 'modal-open' && isMobile) {
      window.history.pushState('modal-open', null, '');
    }
    if (isMobile) window.addEventListener('popstate', onCloseEvents);
  }

  function handleModal(content = false, callback) {
    setModalSettings(null);
    if (callback) {
      callback();
    }

    if (content && isOpen) {
      // Refresca contenido
      setModalContent(content);
    } else if (content) {
      // Abre Modal con contenido
      setModalContent(content);
      onOpenEvents();
    } else {
      // Cierra Modal
      onCloseEvents();
    }
  }

  function isModalOpen() {
    return isOpen;
  }

  const openModal = ({ content, onOpen, settings = null }) => {
    setModalSettings(settings);
    setModalContent(content);
    onOpenEvents();
    if (onOpen) onOpen();
    if (onClose) setOnClose(onClose);
  };

  const setContent = ({ content, onSetModal, settings = null }) => {
    setModalSettings(settings);
    setModalContent(content);

    if (onSetModal) onSetModal();
  };

  const closeModal = ({ onCloseModal }) => {
    onCloseEvents();

    if (onCloseModal) onCloseModal();
  };

  return {
    closeModal,
    openModal,
    modalContent,
    setContent,
    isOpen,
    modalSettings,
    modal,
    handleModal,
    setModal,
    isModalOpen,
    onClose
  };
};
